<template>
  <div class="box">
    <div class="content">
      <div class="tit">
        <p>论文信息</p>
      </div>
      <div class="big_box">
        <p>
          <span class="tit1">论文标题</span> <span>{{ from2.title }}</span>
        </p>
        <p v-if="isPaper">
          <span class="tit1">关键词</span> <span>{{ from2.keywords }}</span>
        </p>
        <p class="big_box2" v-if="isPaper">
          <span class="tit1">摘要正文</span> <span>{{ from2.remark }}</span>
        </p>
        <template v-if="from2.page_status == '2'">
          <p>
            <span class="tit1">期刊名称</span> <span>{{ from2.periodical_name }}</span>
          </p>
          <p>
            <span class="tit1">期刊号</span> <span>{{ from2.periodical_number }}</span>
          </p>
          <p>
            <span class="tit1">JCR分区</span> <span>{{ from2.periodical_jcr }}</span>
          </p>
          <p>
            <span class="tit1">影响因子</span> <span>{{ from2.periodical_factor }}</span>
          </p>
        </template>
        <p>
          <span class="tit1">上传文件</span>
          <span class="tit2" @click="openFlie(from2.fileurl )" v-if="from2.fileurl != ''"
            >查看文件 <i class="el-icon-view"></i
          ></span>
          <span class="tit2" style=" padding-left: 20px; " @click="openFlie(from2.extra_fileurl )" v-if="from2.extra_fileurl != ''"
          >查看文件 <i class="el-icon-view"></i
          ></span>
        </p>
      </div>
      <div class="tit">
        <p>作者信息</p>
      </div>
      <div class="big_box1">
        <div class="fons_red">
          提示：带有
          <img src="../../../assets/img/dianhua2.png" />图标的是通讯作者。
        </div>
        <div class="list_box">
          <div class="list_item" v-for="(item, i) in list" :key="i">
            <div class="list_item_left">
              <p class="w1">{{ item.name }}</p>
              <p class="w2">{{ item.mobile }}</p>
              <p class="w2">{{ item.company }}</p>
              <p class="w2">{{ item.job }}</p>
              <p></p>
            </div>
            <div class="list_item_right">
              {{ item.type == 1 ? '第一作者' : '共同作者' }}
            </div>
          </div>
          <div class="list_item_lats" @click="addFrom" v-if="list.length < 5">
            <img src="../../../assets/img/add_icon.png" alt="" />
            <p>添加作者</p>
          </div>
        </div>
      </div>
      <div class="pr_sta">
        <el-select v-model="status" placeholder="请选择是否投稿">
          <el-option
            v-for="item in options3"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </div>
    </div>
    <div class="big_btn">
      <div>
        <button class="trs_btn" @click="nextSpet(1)">上一步</button>
      </div>
      <div>
        <button @click="sbumit">提交信息</button>
      </div>
    </div>

    <el-dialog
      title="添加作者"
      :visible.sync="centerDialogVisible"
      width="916px"
      center
    >
      <el-form
        label-position="top"
        :model="form"
        :rules="rules"
        ref="ruleForm"
        class="demo-ruleForm form"
        v-if="centerDialogVisible"
      >
        <el-row :gutter="24">
          <el-col :span="12"
            ><el-form-item prop="xing" label="姓氏">
              <el-input v-model="form.xing" placeholder="姓氏"> </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="ming" label="名字">
              <el-input v-model="form.ming" placeholder="名字">
              </el-input> </el-form-item
          ></el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="12"
            ><el-form-item prop="company" label="工作单位">
              <el-input v-model="form.company" placeholder="工作单位">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="job" label="职位/职称">
              <el-input v-model="form.job" placeholder="职位/职称">
              </el-input> </el-form-item
          ></el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="12"
            ><el-form-item prop="email" label="电子邮箱">
              <el-input v-model="form.email" placeholder="电子邮箱"> </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="mobile" label="手机号">
              <el-input v-model="form.mobile" placeholder="手机号">
              </el-input> </el-form-item
          ></el-col>
        </el-row>

        <el-row :gutter="24">
          <el-col :span="12"
            ><el-form-item prop="address" label="通讯地址">
              <el-input v-model="form.address" placeholder="通讯地址">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="phone" label="固定号码">
              <el-input v-model="form.phone" placeholder="固定号码">
              </el-input> </el-form-item
          ></el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="12"
            ><el-form-item prop="ems_code" label="邮编">
              <el-input v-model="form.ems_code" placeholder="邮编"> </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="fax" label="传真">
              <el-input v-model="form.fax" placeholder="传真">
              </el-input> </el-form-item
          ></el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="12"
            ><el-form-item prop="type" label="联合作者">
              <el-select v-model="form.type" placeholder="请选择">
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="is_messager" label="通讯作者">
              <el-select v-model="form.is_messager" placeholder="请选择">
                <el-option
                  v-for="item in options1"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select> </el-form-item
          ></el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <div class="login_fot">
          <button @click="centerDialogVisible = false" class="first">
            取 消
          </button>
          <button @click="sbmit" class="sbmit">
            保 存
          </button>
        </div>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'Home',
  props: {
    bigForm: {}
  },
  data() {
    return {
      list: [],
      form: {},
      from2: {},
      status: '',
      options3: [
        {
          value: 1,
          label: '保存为草稿'
        },
        {
          value: 2,
          label: '继续提交'
        }
      ],
      title: '',
      options1: [
        {
          value: 1,
          label: '是'
        },
        {
          value: 0,
          label: '不是'
        }
      ],
      options: [
        {
          value: 1,
          label: '第一作者'
        },
        {
          value: 2,
          label: '共同作者'
        }
      ],
      id: '',
      centerDialogVisible: false,
      rules: {
        xing: [{ required: true, message: '请输入姓氏', trigger: 'blur' }],
        ming: [{ required: true, message: '请输入名字', trigger: 'blur' }],
        company: [
          { required: true, message: '请输入工作单位', trigger: 'blur' }
        ],
        job: [{ required: true, message: '请输入职务', trigger: 'blur' }],
        email: [{ required: true, message: '请输入邮箱', trigger: 'blur' }],
        mobile: [{ required: true, message: '请输入手机号', trigger: 'blur' }],
        address: [{ required: true, message: '请输入地址', trigger: 'blur' }],
        phone: [{ required: true, message: '请输入固定号码', trigger: 'blur' }],

        ems_code: [{ required: true, message: '请输入邮编', trigger: 'blur' }],
        fax: [{ required: true, message: '请输入传真', trigger: 'blur' }],

        type: [
          { required: true, message: '请选择联合作者类型', trigger: 'change' }
        ],

        is_messager: [
          { required: true, message: '请选择通讯作者', trigger: 'change' }
        ]
      }
    }
  },
  components: {},
  created() {},
  computed: {
    isPaper() {
      return window.localStorage.getItem('typeNum') == 1
    }
  },
  watch: {
    bigForm: {
      handler(val, newval) {
        this.from2 = this.$parent.bigForm.from2
        this.list = this.$parent.bigForm.from1
        console.log(this.$parent.bigForm.from2)
      },
      deep: true
    }
  },
  methods: {
    async sbumit() {
      console.log(this.$parent.bigForm, 'this.$parent.bigForm')
      if (this.status == '') {
        return this.$message.warning('请选择是否投稿')
      }
      let id = this.list.map(x => x.author_ids)
      id = id.join(',')
      let a = {
        title: this.$parent.bigForm.from2.title,
        keywords: this.$parent.bigForm.from2.keywords,
        remark: this.$parent.bigForm.from2.remark,
        province: this.$parent.bigForm.from2.province,
        city: this.$parent.bigForm.from2.city,
        fileurl: this.$parent.bigForm.from2.fileurl,
        extra_fileurl: this.$parent.bigForm.from2.extra_fileurl,
        page_status: this.$parent.bigForm.from2.page_status,
        periodical_name: this.$parent.bigForm.from2.periodical_name,
        periodical_number: this.$parent.bigForm.from2.periodical_number,
        periodical_jcr: this.$parent.bigForm.from2.periodical_jcr,
        periodical_factor: this.$parent.bigForm.from2.periodical_factor,
        type: window.localStorage.getItem('typeNum'),
        author_ids: id,
        status: this.status
      }

      let res = await this.$api.Home.addPaper(a)
      if (res.code == 0) {
        this.id = res.data.id
        this.$message.success('提交成功')
        this.nextSpet(3)
      } else {
        this.$message.success('提交失败')
      }
    },
    nextSpet(val) {
      this.$emit('nextSpet', val)
    },
    openFlie(url) {
      // window.open(this.from2.fileurl, '_blank')
      const a = document.createElement('a')
      a.setAttribute('target', '_blank')
      a.setAttribute(
        'href',
        'http://view.xdocin.com/xdoc?_xdoc=' + url
      )
      a.click()

      // const a = document.createElement('a')
      // a.download = true
      // a.style.display = 'block'
      // a.href = this.from2.fileurl
      // // 触发点击
      // document.body.appendChild(a)
      // a.click()
      // // 然后移除
      // document.body.removeChild(a)
    },
    getid() {
      return this.id
    },
    async sbmit() {
      this.$refs.ruleForm.validate(async valid => {
        if (valid) {
          const res = await this.$api.Home.addAuth(this.form)
          let a = {
            name: res.data.xing + res.data.ming,
            mobile: res.data.mobile,
            company: res.data.company,
            job: res.data.job,
            type: res.data.type
          }

          if (res.code == 0) {
            this.list.push(a)

            this.centerDialogVisible = false

            this.$message.success('添加作者成功')
          } else {
            this.$message.error('添加作者失败')
          }
        } else {
          return false
        }
      })
    },
    addFrom() {
      this.form = {
        xing: '',
        ming: '',
        company: '',
        job: '',
        email: '',
        mobile: '',
        address: '',
        phone: '',
        ems_code: '',
        fax: '',
        type: '',
        is_messager: ''
      }
      this.centerDialogVisible = true
    }
  }
}
</script>
<style lang="less" scoped>
.pr_sta {
  margin-top: 20px;
}
.login_fot {
  margin-top: 30px;
  display: flex;
  justify-content: center;
  .first {
    background-color: #ffffff;
  }
  .sbmit {
    color: #ffffff;
  }
  button {
    margin-right: 30px;
    width: 120px;
    height: 60px;
    background-color: #00599e;
    border-radius: 5px;
    border: solid 1px #eeeeee;
    font-family: 'SourceHanSansCN-Regular';
    font-size: 24px;
    font-weight: normal;
    font-stretch: normal;
    letter-spacing: 0px;
    color: #666666;
    cursor: pointer;
  }
}
.box {
  background-color: #f6fbff;
  .content {
    width: 1200px;
    // height: 744px;
    background-color: #ffffff;
    padding: 42px 50px 45px 50px;
    box-sizing: border-box;
    .tit {
      p {
        font-family: SourceHanSansCN-Regular;
        font-size: 30px;
        font-weight: normal;
        font-stretch: normal;
        line-height: 24px;
        letter-spacing: 0px;
        color: #00599e;
      }
      padding-bottom: 20px;
      box-sizing: border-box;
      border-bottom: 2px solid #c9dcea;
    }
    .big_box {
      margin-bottom: 50px;
      p {
        margin-top: 35px;
        font-size: 18px;
        color: #333;
        .tit1 {
          margin-left: 50px;
          width: 100px;
          display: inline-block;
          color: #888;
        }
        .tit2 {
          color: #00599e !important;
        }
      }
    }
    .big_box2 {
      width: 100%;
      line-height: 24px;
       word-break: break-all;
    }
    .big_box1 {
      margin-top: 30px;
      width: 1200px;
      box-sizing: border-box;
      .fons_red {
        display: flex;
        height: 18px;
        line-height: 18px;
        font-family: ' SourceHanSansCN-Regular';
        font-size: 18px;
        font-weight: normal;
        font-stretch: normal;
        letter-spacing: 0px;
        color: #fe0201;
        img {
          margin: 0 3px;
          width: 18px;
          height: 18px;
        }
      }
    }
    .list_box {
      display: flex;
      margin-top: 22px;
      flex-wrap: wrap;
      .list_item_lats {
        width: 300px;
        height: 200px;
        background-color: #ffffff;
        border-radius: 5px;
        border: solid 1px #eeeeee;
        display: flex;
        flex-direction: column;
        cursor: pointer;
        align-items: center;
        justify-content: center;
        p {
          margin-top: 16px;
          font-family: 'SourceHanSansCN-Regular';
          font-size: 18px;
          font-weight: normal;
          font-stretch: normal;
          letter-spacing: 0px;
          color: #c9dcea;
        }
      }
    }
    .list_item {
      margin-right: 20px;
      margin-bottom: 10px;
      width: 300px;
      height: 200px;
      background-color: #ffffff;
      border-radius: 5px;
      border: solid 1px #eeeeee;
      position: relative;
      .list_item_left {
        margin-top: 40px;
        margin-left: 40px;
        .w1 {
          color: #00599e;
          font-size: 20px;
          margin-bottom: 30px;
        }
        .w2 {
          color: #888888;
          font-size: 18px;
        }
      }
      .list_item_right {
        position: absolute;
        right: 0;
        top: 30px;
        width: 130px;
        height: 40px;
        font-size: 16px;
        line-height: 40px;
        background: url('../../../assets/img/dianhua.png');
        text-indent: 50px;
        color: #fff;
      }
    }
  }
  .big_btn {
    width: 440px;
    display: flex;
    justify-content: space-between;
    margin: 0 auto;
    .trs_btn {
      width: 200px;
      height: 60px;
      border-radius: 5px;
      background: #fff;
      border: solid 1px #c9dcea;
      font-family: SourceHanSansCN-Regular;
      font-size: 20px;
      font-weight: normal;
      font-stretch: normal;
      letter-spacing: 0px;
      color: #00599e;
    }
    button {
      width: 200px;
      height: 60px;
      background-color: #00599e;
      border-radius: 5px;
      border: 0;
      font-size: 20px;

      color: #fff;
      margin-top: 40px;
      margin-bottom: 73px;
    }
  }
}
</style>
